
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5af7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5af7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lA1wN", function(module, exports) {

$parcel$export(module.exports, "initHeaderActiveNav", function () { return $fb5e25347d6b7784$export$9a4306cb330df17c; });
$parcel$export(module.exports, "initHeaderCTA", function () { return $fb5e25347d6b7784$export$439db37d80004144; });
// assets/js/layout/header.js
function $fb5e25347d6b7784$export$9a4306cb330df17c() {
    const page = document.body.dataset.page;
    if (!page) return;
    document.querySelectorAll('.top-bar__nav-pill a, .top-bar__nav-panel a').forEach((link)=>{
        if (link.dataset.nav === page) link.classList.add('is-active');
    });
}
function $fb5e25347d6b7784$export$439db37d80004144() {
    const cta = document.querySelector('[data-header-cta]');
    if (!cta) return;
    const page = document.body.dataset.page;
    switch(page){
        case 'inicio':
        case 'cuestionarios':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'planes':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'info':
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html#register">Reg\xedstrate gratis</a>
			`;
            break;
        case 'app':
            cta.innerHTML = `
				<!-- \u{1F510} AUTH BAR (renderizada por AuthHeaderController + AuthHeaderView) -->
				<div class="auth-bar" data-auth-header></div>
			`;
            break;
        default:
            cta.innerHTML = `
				<a class="btn btn-primary" href="app.html">[...to be configured]</a>
			`;
    }
}

});

// src/assets/js/pages/quizzes/main.js

var $lA1wN = parcelRequire("lA1wN");
// src/assets/js/quizzes/bom/QuizzesState.js
// BOM: estado + lógica pura (sin DOM, sin fetch, sin render)
// Número de quizzes por página (paginación)
const $4e5ab73602d3c74b$var$DEFAULT_PAGE_SIZE = 10;
class $4e5ab73602d3c74b$export$8f193c612aecdea {
    /**
	 * @param {object} [initial]
	 * @param {'subjects'|'list'} [initial.viewMode]
	 * @param {string|null} [initial.subjectId]
	 * @param {string|null} [initial.regionId]
	 * @param {string} [initial.query]
	 * @param {number} [initial.pageSize]
	 * @param {number} [initial.visibleCount]
	 */ constructor(initial = {}){
        this._listeners = new Set();
        this._state = {
            viewMode: initial.viewMode || 'subjects',
            subjectId: initial.subjectId ?? null,
            regionId: initial.regionId ?? null,
            query: (initial.query || '').trim(),
            pageSize: Number.isFinite(initial.pageSize) ? initial.pageSize : $4e5ab73602d3c74b$var$DEFAULT_PAGE_SIZE,
            visibleCount: Number.isFinite(initial.visibleCount) ? initial.visibleCount : Number.isFinite(initial.pageSize) ? initial.pageSize : $4e5ab73602d3c74b$var$DEFAULT_PAGE_SIZE
        };
    }
    /* =========================
	   Suscripción / eventos
	========================= */ /**
	 * @param {(snapshot: object, meta?: object) => void} fn
	 * @returns {() => void} unsubscribe
	 */ subscribe(fn) {
        if (typeof fn !== 'function') return ()=>{};
        this._listeners.add(fn);
        // Primera notificación opcional (útil para pintar inicial)
        fn(this.getSnapshot(), {
            type: 'init'
        });
        return ()=>this._listeners.delete(fn);
    }
    _notify(meta) {
        const snap = this.getSnapshot();
        for (const fn of this._listeners)fn(snap, meta);
    }
    /* =========================
	   Lectura de estado
	========================= */ getSnapshot() {
        // copia inmutable para evitar mutaciones externas
        return {
            ...this._state
        };
    }
    get viewMode() {
        return this._state.viewMode;
    }
    get subjectId() {
        return this._state.subjectId;
    }
    get regionId() {
        return this._state.regionId;
    }
    get query() {
        return this._state.query;
    }
    get pageSize() {
        return this._state.pageSize;
    }
    get visibleCount() {
        return this._state.visibleCount;
    }
    /* =========================
	   Mutaciones (API pública)
	========================= */ setViewMode(viewMode) {
        const next = viewMode === 'list' ? 'list' : 'subjects';
        if (this._state.viewMode === next) return;
        this._state.viewMode = next;
        // Cambiar de vista no obliga a resetear filtros, pero sí suele resetear paginación
        this.resetPagination({
            silent: true
        });
        this._notify({
            type: 'viewMode',
            value: next
        });
    }
    /**
	 * Toggle de materia:
	 * - si clicas la misma, se deselecciona
	 * - al seleccionar materia -> vista 'list'
	 * - al deseleccionar -> vista 'subjects' (si no hay query activa)
	 */ toggleSubject(subjectId) {
        const id = subjectId ? String(subjectId) : null;
        const prev = this._state.subjectId;
        this._state.subjectId = prev === id ? null : id;
        this.resetPagination({
            silent: true
        });
        // lógica UX: si hay materia -> lista, si no hay -> subjects (salvo búsqueda activa)
        if (this._state.subjectId) this._state.viewMode = 'list';
        else if (!this._state.query) this._state.viewMode = 'subjects';
        this._notify({
            type: 'subject',
            value: this._state.subjectId
        });
    }
    setSubject(subjectId) {
        const id = subjectId ? String(subjectId) : null;
        if (this._state.subjectId === id) return;
        this._state.subjectId = id;
        this.resetPagination({
            silent: true
        });
        this._applyAutoViewMode();
        this._notify({
            type: 'subject',
            value: id
        });
    }
    clearSubject() {
        if (this._state.subjectId === null) return;
        this._state.subjectId = null;
        this.resetPagination({
            silent: true
        });
        this._applyAutoViewMode();
        this._notify({
            type: 'subject',
            value: null
        });
    }
    setRegion(regionId) {
        const id = regionId ? String(regionId) : null;
        if (this._state.regionId === id) return;
        this._state.regionId = id;
        this.resetPagination({
            silent: true
        });
        // si hay materia elegida, seguimos en lista; si no, seguimos en subjects
        this._applyAutoViewMode();
        this._notify({
            type: 'region',
            value: id
        });
    }
    clearRegion() {
        if (this._state.regionId === null) return;
        this._state.regionId = null;
        this.resetPagination({
            silent: true
        });
        this._applyAutoViewMode();
        this._notify({
            type: 'region',
            value: null
        });
    }
    setQuery(text) {
        const q = String(text || '').trim();
        if (this._state.query === q) return;
        this._state.query = q;
        this.resetPagination({
            silent: true
        });
        // UX: si hay búsqueda -> lista; si no hay búsqueda y no hay materia -> subjects
        this._applyAutoViewMode();
        this._notify({
            type: 'query',
            value: q
        });
    }
    clearQuery() {
        if (!this._state.query) return;
        this._state.query = '';
        this.resetPagination({
            silent: true
        });
        this._applyAutoViewMode();
        this._notify({
            type: 'query',
            value: ''
        });
    }
    setPageSize(n) {
        const next = Number(n);
        if (!Number.isFinite(next) || next <= 0) return;
        if (this._state.pageSize === next) return;
        this._state.pageSize = next;
        this._state.visibleCount = next;
        this._notify({
            type: 'pageSize',
            value: next
        });
    }
    /**
	 * "Cargar más" (incremental)
	 * @param {number} [step] por defecto pageSize
	 */ loadMore(step) {
        const inc = Number.isFinite(step) ? Number(step) : this._state.pageSize;
        if (!Number.isFinite(inc) || inc <= 0) return;
        this._state.visibleCount += inc;
        this._notify({
            type: 'loadMore',
            value: this._state.visibleCount
        });
    }
    resetPagination({ silent: silent = false } = {}) {
        this._state.visibleCount = this._state.pageSize;
        if (!silent) this._notify({
            type: 'resetPagination'
        });
    }
    /**
	 * Reset completo (útil para botón "Limpiar filtros")
	 */ resetAll() {
        this._state.viewMode = 'subjects';
        this._state.subjectId = null;
        this._state.regionId = null;
        this._state.query = '';
        this._state.visibleCount = this._state.pageSize;
        this._applyAutoViewMode();
        this._notify({
            type: 'resetAll'
        });
    }
    /* =========================
	   Helpers de consulta
	========================= */ /**
	 * @returns {boolean} true si hay cualquier filtro activo
	 */ hasFilters() {
        return Boolean(this._state.subjectId || this._state.regionId || this._state.query);
    }
    /**
	 * El controller/servicio lo usará para filtrar quizzes
	 */ getFilterParams() {
        return {
            subjectId: this._state.subjectId,
            regionId: this._state.regionId,
            query: this._state.query
        };
    }
    /* =========================
	   Helpers privados
	========================= */ _applyAutoViewMode() {
        const hasSubject = !!this._state.subjectId;
        const hasQuery = !!(this._state.query && this._state.query.trim());
        this._state.viewMode = hasSubject || hasQuery ? 'list' : 'subjects';
        console.log('[QuizzesState] viewMode:', this._state.viewMode);
    }
}


// src/assets/js/quizzes/controllers/QuizzesController.js
// Orquesta: carga datos (via service), escucha View, muta State, decide qué renderizar.
// src/assets/js/shared/favorites-apply.js
const $50f652c3ec429727$var$DEFAULT_STORAGE_KEY = 'selectivia:favs';
const $50f652c3ec429727$var$MAX_FAVS = 9;
function $50f652c3ec429727$var$safeParse(json, fallback) {
    try {
        return JSON.parse(json);
    } catch  {
        return fallback;
    }
}
function $50f652c3ec429727$var$loadFavs(storageKey = $50f652c3ec429727$var$DEFAULT_STORAGE_KEY) {
    const raw = localStorage.getItem(storageKey);
    const data = $50f652c3ec429727$var$safeParse(raw, {
        quizzes: []
    });
    const quizzes = Array.isArray(data?.quizzes) ? data.quizzes : [];
    return quizzes.map((q)=>({
            quizId: String(q?.quizId || '').trim(),
            subjectId: String(q?.subjectId || '').trim(),
            subjectTitle: String(q?.subjectTitle || '').trim(),
            quizTitle: String(q?.quizTitle || '').trim()
        })).filter((q)=>q.quizId);
}
function $50f652c3ec429727$var$saveFavs(storageKey, favs) {
    localStorage.setItem(storageKey, JSON.stringify({
        quizzes: favs
    }));
}
function $50f652c3ec429727$var$setStarIcon(btn, isFav) {
    btn.classList.toggle('is-fav', isFav);
    btn.setAttribute('aria-pressed', String(isFav));
}
function $50f652c3ec429727$var$readDataset(btn) {
    return {
        quizId: String(btn.dataset.quizId || '').trim(),
        subjectId: String(btn.dataset.subjectId || '').trim(),
        subjectTitle: String(btn.dataset.subjectTitle || '').trim(),
        quizTitle: String(btn.dataset.quizTitle || '').trim()
    };
}
function $50f652c3ec429727$export$3ed93091135e143f({ root: root = document, storageKey: storageKey = $50f652c3ec429727$var$DEFAULT_STORAGE_KEY } = {}) {
    if (!root) root = document;
    function getFavSet() {
        const favs = $50f652c3ec429727$var$loadFavs(storageKey);
        return new Set(favs.map((f)=>f.quizId));
    }
    function apply(scope = root) {
        const favSet = getFavSet();
        scope.querySelectorAll('[data-action="fav-quiz"]').forEach((btn)=>{
            const quizId = String(btn.dataset.quizId || '').trim();
            if (!quizId) {
                btn.disabled = true;
                $50f652c3ec429727$var$setStarIcon(btn, false);
                return;
            }
            btn.disabled = false;
            $50f652c3ec429727$var$setStarIcon(btn, favSet.has(quizId));
        });
    }
    function toggleEverywhere(quizId) {
        const qid = String(quizId || '').trim();
        if (!qid) return;
        const favSet = getFavSet();
        root.querySelectorAll(`[data-action="fav-quiz"][data-quiz-id="${CSS.escape(qid)}"]`).forEach((btn)=>$50f652c3ec429727$var$setStarIcon(btn, favSet.has(qid)));
    }
    function onClick(e) {
        const btn = e.target?.closest?.('[data-action="fav-quiz"]');
        if (!btn || !root.contains(btn)) return;
        // Importante: que NO dispare el click del botón "open-quiz"
        e.preventDefault();
        e.stopPropagation();
        const { quizId: quizId, subjectId: subjectId, subjectTitle: subjectTitle, quizTitle: quizTitle } = $50f652c3ec429727$var$readDataset(btn);
        if (!quizId) return;
        let favs = $50f652c3ec429727$var$loadFavs(storageKey);
        const favSet = new Set(favs.map((f)=>f.quizId));
        const isFav = favSet.has(quizId);
        if (isFav) {
            favs = favs.filter((f)=>f.quizId !== quizId);
            $50f652c3ec429727$var$saveFavs(storageKey, favs);
            toggleEverywhere(quizId);
            return;
        }
        if (favSet.size >= $50f652c3ec429727$var$MAX_FAVS) // aquí si quieres puedes reutilizar tu shake()
        return;
        favs = [
            ...favs.filter((f)=>f.quizId !== quizId),
            {
                quizId: quizId,
                subjectId: subjectId,
                subjectTitle: subjectTitle,
                quizTitle: quizTitle
            }
        ];
        $50f652c3ec429727$var$saveFavs(storageKey, favs);
        toggleEverywhere(quizId);
    }
    // Evita doble bind
    if (!root.__favoritesApplyBound__) {
        root.addEventListener('click', onClick);
        root.__favoritesApplyBound__ = true;
    }
    // Pintado inicial (por si ya hay botones en DOM)
    apply(root);
    return {
        apply: apply
    };
}



// src/assets/js/quizzes/ui/QuizzesView.js
// UI pura: render + listeners. No fetch, no state, no reglas.
class $6c4bdedaa4ec98dc$export$d01b8c10d7ef31c1 {
    /**
	 * @param {object} params
	 * @param {HTMLElement} params.root
	 * @param {object} [params.selectors]
	 */ constructor({ root: root, selectors: selectors = {} } = {}){
        if (!root) throw new Error('[QuizzesView] root is required');
        this.root = root;
        this.sel = {
            subjectsGrid: selectors.subjectsGrid || '[data-quizzes-subjects-grid]',
            list: selectors.list || '[data-quizzes-list]',
            listItems: selectors.listItems || '[data-quizzes-list-items]',
            searchInput: selectors.searchInput || '[data-quizzes-search-input]',
            subjectSelect: selectors.subjectSelect || '[data-quizzes-subject-select]',
            regionSelect: selectors.regionSelect || '[data-quizzes-region-select]',
            clearBtn: selectors.clearBtn || '[data-quizzes-clear]',
            loadMoreBtn: selectors.loadMoreBtn || '[data-quizzes-load-more]',
            viewToggleSubjects: selectors.viewToggleSubjects || '[data-quizzes-view="subjects"]',
            viewToggleRegions: selectors.viewToggleRegions || '[data-quizzes-view="regions"]',
            regionsGrid: selectors.regionsGrid || '[data-quizzes-regions-grid]',
            status: selectors.status || '[data-quizzes-status]',
            pager: selectors.pager || '[data-quizzes-pager]',
            loadedCount: selectors.loadedCount || '[data-quizzes-loaded]',
            totalCount: selectors.totalCount || '[data-quizzes-total]',
            resultsCount: selectors.resultsCount || '[data-quizzes-count]',
            ...selectors
        };
        this.tpl = {
            subjectCard: this._getTemplate('#tpl-subject-card'),
            quizItem: this._getTemplate('#tpl-quiz-item'),
            regionCard: this._getTemplate('#tpl-region-card')
        };
        this.els = {
            subjectsGrid: this.root.querySelector(this.sel.subjectsGrid),
            list: this.root.querySelector(this.sel.list),
            listItems: this.root.querySelector(this.sel.listItems),
            searchInput: this.root.querySelector(this.sel.searchInput),
            subjectSelect: this.root.querySelector(this.sel.subjectSelect),
            regionSelect: this.root.querySelector(this.sel.regionSelect),
            clearBtn: this.root.querySelector(this.sel.clearBtn),
            loadMoreBtn: this.root.querySelector(this.sel.loadMoreBtn),
            viewToggleSubjects: this.root.querySelector(this.sel.viewToggleSubjects),
            viewToggleRegions: this.root.querySelector(this.sel.viewToggleRegions),
            regionsGrid: this.root.querySelector(this.sel.regionsGrid),
            status: this.root.querySelector(this.sel.status),
            pager: this.root.querySelector(this.sel.pager),
            loadedCount: this.root.querySelector(this.sel.loadedCount),
            totalCount: this.root.querySelector(this.sel.totalCount),
            resultsCount: this.root.querySelector(this.sel.resultsCount)
        };
        this._handlers = {};
    }
    /* =========================
	   Public events (Controller hooks)
	========================= */ on(eventName, handler) {
        this._handlers[eventName] = handler;
    }
    bindUI() {
        // Search
        if (this.els.searchInput) this.els.searchInput.addEventListener('input', (e)=>{
            this._emit('search', {
                query: e.target.value
            });
        });
        // Subject select
        if (this.els.subjectSelect) this.els.subjectSelect.addEventListener('change', (e)=>{
            const subjectId = e.target.value || null;
            console.log('[QuizzesView] emit subject', subjectId);
            this._emit('subject', {
                subjectId: subjectId
            });
        });
        // Region select (optional)
        if (this.els.regionSelect) this.els.regionSelect.addEventListener('change', (e)=>{
            const value = e.target.value || null;
            console.log('[QuizzesView] emit region', regionId);
            this._emit('region', {
                regionId: value
            });
        });
        // Clear filters
        if (this.els.clearBtn) this.els.clearBtn.addEventListener('click', ()=>{
            this._emit('clear');
        });
        // Load more
        if (this.els.loadMoreBtn) this.els.loadMoreBtn.addEventListener('click', ()=>{
            this._emit('loadMore');
        });
        // View toggles
        if (this.els.viewToggleSubjects) this.els.viewToggleSubjects.addEventListener('click', ()=>{
            this._emit('view', {
                viewMode: 'subjects'
            });
        });
        if (this.els.viewToggleRegions) this.els.viewToggleRegions.addEventListener('click', ()=>{
            this._emit('view', {
                viewMode: 'regions'
            });
        });
        if (this.els.subjectsGrid) this.els.subjectsGrid.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-action]');
            if (!btn) return;
            const action = btn.dataset.action;
            if (action === 'open-subject') {
                const subjectId = String(btn.dataset.subjectId || '').trim();
                if (!subjectId) return;
                e.preventDefault();
                e.stopPropagation();
                this._emit('openSubject', {
                    subjectId: subjectId
                });
                return;
            }
            if (action === 'select-subject') this._emit('subject', {
                subjectId: btn.dataset.subjectId || null
            });
        });
        // Delegación: click en cards de regiones
        if (this.els.regionsGrid) this.els.regionsGrid.addEventListener('click', (e)=>{
            const btn = e.target.closest('[data-action="select-region"]');
            if (!btn) return;
            this._emit('region', {
                regionId: btn.dataset.regionId || null
            });
        });
        // Delegación: items de quiz (por si añades acciones)
        if (this.els.listItems) this.els.listItems.addEventListener('click', (e)=>{
            const openBtn = e.target.closest('[data-action="open-quiz"]');
            if (!openBtn) return;
            this._emit('openQuiz', {
                subjectId: openBtn.dataset.subjectId || null,
                quizId: openBtn.dataset.quizId || null
            });
        });
    }
    /* =========================
	   Render API (Controller calls)
	========================= */ setStatus(text) {
        if (!this.els.status) return;
        this.els.status.textContent = text || '';
        this.els.status.style.display = text ? '' : 'none';
    }
    setActiveView(mode) {
        const isSubjects = mode === 'subjects';
        const isList = mode === 'list';
        // Subjects grid
        if (this.els.subjectsGrid) this.els.subjectsGrid.toggleAttribute('hidden', !isSubjects);
        // Quizzes list container (wrapper)
        if (this.els.list) this.els.list.toggleAttribute('hidden', !isList);
        // Pager: solo en list
        if (this.els.pager) this.els.pager.toggleAttribute('hidden', !isList);
    }
    renderSubjectOptions(subjects = []) {
        if (!this.els.subjectSelect) return;
        // Mantén "Todas" y rellena el resto
        this.els.subjectSelect.innerHTML = '<option value="">Todas</option>';
        for (const s of subjects){
            const opt = document.createElement('option');
            opt.value = String(s.subjectId || '');
            opt.textContent = String(s.subjectTitle || s.subjectId || '');
            this.els.subjectSelect.appendChild(opt);
        }
    }
    render(vm) {
        this.setActiveView(vm.viewMode);
        this.setInputs(vm.inputs);
        this.setPagerStatus(vm.pager);
        this.setPagerVisibility(vm);
        if (vm.viewMode === 'subjects') this.renderSubjects(vm.subjectCards);
        else this.renderQuizList(vm.quizItems);
    }
    renderSubjects(subjectCards = []) {
        if (!this.els.subjectsGrid) return;
        this.els.subjectsGrid.innerHTML = '';
        const frag = document.createDocumentFragment();
        for (const card of subjectCards){
            const node = this._clone(this.tpl.subjectCard);
            // -----------------------------
            // Datos base
            // card: { subjectId, subjectTitle, total, latest: [{ quizId, quizTitle, region, regionId }] }
            // -----------------------------
            const subjectId = String(card.subjectId || '');
            const subjectTitle = String(card.subjectTitle || 'Materia');
            const total = Number.isFinite(card.total) ? card.total : Number(card.total ?? 0);
            const article = node.querySelector('.subject-card');
            if (article) article.dataset.subject = subjectId;
            // Nombre materia
            const nameEl = node.querySelector('.subject-card__name');
            if (nameEl) nameEl.textContent = subjectTitle;
            // Icono materia (mismo patrón que index.html)
            const iconEl = node.querySelector('.subject-card__icon');
            if (iconEl) iconEl.setAttribute('data-icon', `subject-${subjectId}-icon`);
            // Count
            const countStrong = node.querySelector('.subject-card__count strong');
            if (countStrong) countStrong.textContent = String(total);
            // Botón "ver materia"
            const openBtn = node.querySelector('[data-action="open-subject"], [data-action="select-subject"], [data-quizzes-open-subject]');
            if (openBtn) {
                openBtn.dataset.subjectId = subjectId;
                openBtn.dataset.subjectTitle = subjectTitle;
            }
            // -----------------------------
            // Últimos 2–3 quizzes
            // -----------------------------
            const list = node.querySelector('.subject-card__list');
            if (list) {
                list.innerHTML = '';
                (card.latest || []).slice(0, 3).forEach((q)=>{
                    const li = document.createElement('li');
                    const quizTitle = String(q.quizTitle || q.title || 'Quiz');
                    const quizId = String(q.quizId || q.id || '');
                    const regionName = q.region ? String(q.region) : null;
                    const regionId1 = q.regionId ? String(q.regionId) : null;
                    // Título (si quieres mostrar región, lo metemos aquí en pequeño)
                    const titleSpan = document.createElement('span');
                    titleSpan.className = 'subject-card__quiz-title';
                    titleSpan.textContent = regionName ? `${quizTitle} \xb7 [${regionId1}]` : quizTitle;
                    // ⭐ Botón favorito (nuevo sistema multicolor)
                    const favBtn = document.createElement('button');
                    favBtn.className = 'fav-btn';
                    favBtn.type = 'button';
                    favBtn.setAttribute('data-action', 'fav-quiz');
                    favBtn.setAttribute('aria-label', 'Marcar como favorito');
                    favBtn.setAttribute('aria-pressed', 'false');
                    // dataset necesario para favorites.js
                    favBtn.dataset.quizId = quizId;
                    favBtn.dataset.quizTitle = quizTitle;
                    favBtn.dataset.subjectId = subjectId;
                    favBtn.dataset.subjectTitle = subjectTitle;
                    if (regionName) favBtn.dataset.region = regionName;
                    if (regionId1) favBtn.dataset.regionId = regionId1;
                    favBtn.disabled = !quizId;
                    // Icono (multicolor vía CSS)
                    const icon = document.createElement('span');
                    icon.className = 'fav-icon fav-icon--mini';
                    icon.setAttribute('aria-hidden', 'true');
                    favBtn.appendChild(icon);
                    li.appendChild(titleSpan);
                    li.appendChild(document.createTextNode(' '));
                    li.appendChild(favBtn);
                    list.appendChild(li);
                });
            }
            frag.appendChild(node);
        }
        this.els.subjectsGrid.appendChild(frag);
    }
    renderRegions(regionCards = []) {
        if (!this.els.regionsGrid) return;
        this.els.regionsGrid.innerHTML = '';
        const frag = document.createDocumentFragment();
        for (const card of regionCards){
            const node = this._clone(this.tpl.regionCard);
            // card: { regionId, regionName, total }
            node.querySelector('[data-bind="regionName"]')?.replaceChildren(document.createTextNode(card.regionName || "Regi\xf3n"));
            node.querySelector('[data-bind="count"]')?.replaceChildren(document.createTextNode(String(card.total ?? 0)));
            const btn = node.querySelector('[data-action="select-region"]');
            if (btn) btn.dataset.regionId = card.regionId;
            frag.appendChild(node);
        }
        this.els.regionsGrid.appendChild(frag);
    }
    renderQuizList(items = []) {
        if (!this.els.listItems) return;
        this.els.listItems.innerHTML = '';
        const frag = document.createDocumentFragment();
        //items = Array(100).fill(items).flat();
        for (const item of items){
            const node = this._clone(this.tpl.quizItem);
            // item: { quizId, quizTitle, subjectId, subjectTitle, region, regionId }
            const quizId = String(item.quizId || '');
            const quizTitle = String(item.quizTitle || 'Quiz');
            const subjectId = String(item.subjectId || '');
            const subjectTitle = String(item.subjectTitle || '');
            const region = String(item.region || '');
            const regionId1 = String(item.regionId || '');
            const meta = String(item.meta || item.exam || item.call || '');
            node.querySelector('[data-bind="quizTitle"]')?.replaceChildren(document.createTextNode(item.quizTitle || 'Quiz'));
            node.querySelector('[data-bind="subjectTitle"]')?.replaceChildren(document.createTextNode(item.subjectTitle || ''));
            node.querySelector('[data-bind="region"]')?.replaceChildren(document.createTextNode(item.region || ''));
            // meta pill (opcional)
            const metaEl = node.querySelector('[data-bind="meta"]');
            if (metaEl) {
                if (meta) {
                    metaEl.replaceChildren(document.createTextNode(meta));
                    metaEl.toggleAttribute('hidden', false);
                } else {
                    metaEl.replaceChildren(document.createTextNode(''));
                    metaEl.toggleAttribute('hidden', true);
                }
            }
            // ✅ Icono de materia (reusa subject-icons.scss)
            const iconEl = node.querySelector('[data-bind="subjectIcon"]');
            if (iconEl) {
                iconEl.classList.add('subject-icon'); // asegura ::before
                // Ej: subject-matematicas_ii-icon
                iconEl.dataset.icon = item.subjectId ? `subject-${item.subjectId}-icon` : '';
                iconEl.toggleAttribute('hidden', !item.subjectId);
            }
            // Botón abrir quiz
            const openBtn = node.querySelector('[data-action="open-quiz"]');
            if (openBtn) {
                openBtn.dataset.quizId = quizId;
                openBtn.dataset.subjectId = subjectId;
                openBtn.dataset.quizTitle = quizTitle;
                openBtn.dataset.subjectTitle = subjectTitle;
                if (region) openBtn.dataset.region = region;
                if (regionId1) openBtn.dataset.regionId = regionId1;
            }
            // ⭐ Botón favorito (ESTO ES LO QUE FALTABA)
            const favBtn = node.querySelector('[data-action="fav-quiz"]');
            if (favBtn) {
                favBtn.dataset.quizId = quizId || '';
                favBtn.dataset.quizTitle = quizTitle || '';
                favBtn.dataset.subjectId = subjectId || '';
                favBtn.dataset.subjectTitle = subjectTitle || '';
                if (region) favBtn.dataset.region = region;
                if (regionId1) favBtn.dataset.regionId = regionId1;
                favBtn.disabled = !quizId; // si no hay quizId, se deshabilita
            }
            frag.appendChild(node);
        }
        this.els.listItems.appendChild(frag);
    }
    setPagerVisibility({ viewMode: viewMode, pager: pager }) {
        const visible = viewMode === 'list' && pager?.hasMore;
        if (this.els.pager) this.els.pager.toggleAttribute('hidden', !visible);
    }
    setPagerStatus({ loaded: loaded = 0, total: total = 0 } = {}) {
        if (this.els.loadedCount) this.els.loadedCount.textContent = String(loaded);
        if (this.els.totalCount) this.els.totalCount.textContent = String(total);
        if (this.els.resultsCount) this.els.resultsCount.textContent = String(total); // "X resultados" (opcional)
    }
    setInputs({ query: query, regionId: regionId1, subjectId: subjectId } = {}) {
        if (this.els.searchInput && typeof query === 'string') this.els.searchInput.value = query;
        if (this.els.subjectSelect) this.els.subjectSelect.value = subjectId || '';
        if (this.els.regionSelect) this.els.regionSelect.value = regionId1 || '';
    }
    /* =========================
	   Internals
	========================= */ _emit(name, payload) {
        const fn = this._handlers[name];
        if (typeof fn === 'function') fn(payload || {});
    }
    _getTemplate(id) {
        const tpl = document.querySelector(id);
        // Permite arrancar sin templates, pero avisamos
        if (!tpl) return null;
        return tpl;
    }
    _clone(tpl) {
        if (!tpl) return document.createElement('div');
        const fragment = tpl.content.cloneNode(true);
        // devolvemos primer elemento “útil”
        return fragment.firstElementChild || fragment;
    }
    _toggleActive(el, isActive) {
        if (!el) return;
        el.classList.toggle('is-active', Boolean(isActive));
    }
    _trimToAlphanumeric(text = '', max = 12, minAlnumTail = 3) {
        const str = String(text).trim();
        if (str.length <= max) return str;
        // Cortamos un poco más largo para poder ajustar
        let cut = str.slice(0, max + minAlnumTail);
        // Buscamos el último punto donde haya al menos minAlnumTail alfanuméricos seguidos
        const regex = new RegExp(`([a-zA-Z0-9\xe1\xe9\xed\xf3\xfa\xc1\xc9\xcd\xd3\xda\xf1\xd1\xfc\xdc]{${minAlnumTail},})[^a-zA-Z0-9\xe1\xe9\xed\xf3\xfa\xc1\xc9\xcd\xd3\xda\xf1\xd1\xfc\xdc]*$`, 'u');
        const match = cut.match(regex);
        if (match) cut = cut.slice(0, cut.lastIndexOf(match[1]) + match[1].length);
        else // fallback seguro
        cut = cut.slice(0, max).replace(/\W+$/u, '');
        return cut + "\u2026";
    }
}


// De momento el Service lo dejaremos “inline” para no meter otro fichero aún.
// En el siguiente paso lo separamos a services/QuizzesIndexService.js (100% recomendado).
async function $df720c5fae68234e$var$fetchIndexJson(indexUrl) {
    const res = await fetch(indexUrl, {
        cache: 'no-store'
    });
    if (!res.ok) throw new Error(`Failed to load index.json (${res.status})`);
    return res.json();
}
function $df720c5fae68234e$var$flattenIndex(indexJson) {
    // indexJson: { total, subjects: [{ subjectId, subjectTitle, quizzes: [{quizId, quizTitle, region, regionId}] }] }
    const out = [];
    const subjects = Array.isArray(indexJson?.subjects) ? indexJson.subjects : [];
    for (const s of subjects){
        const subjectId = s.subjectId;
        const subjectTitle = s.subjectTitle;
        const quizzes = Array.isArray(s.quizzes) ? s.quizzes : [];
        for (const q of quizzes)out.push({
            subjectId: subjectId,
            subjectTitle: subjectTitle,
            quizId: q.quizId,
            quizTitle: q.quizTitle,
            region: q.region || null,
            regionId: q.regionId || null
        });
    }
    return out;
}
function $df720c5fae68234e$var$buildRegionsAgg(flatItems) {
    const map = new Map(); // regionId -> { regionId, regionName, total }
    for (const item of flatItems){
        const rid = item.regionId || 'sin_region';
        const rname = item.region || (rid === 'sin_region' ? "Sin regi\xf3n" : rid);
        const prev = map.get(rid) || {
            regionId: rid,
            regionName: rname,
            total: 0
        };
        prev.total += 1;
        map.set(rid, prev);
    }
    return Array.from(map.values()).sort((a, b)=>b.total - a.total);
}
function $df720c5fae68234e$var$filterItems(flatItems, { subjectId: subjectId, regionId: regionId, query: query }) {
    let items = flatItems;
    if (subjectId) items = items.filter((x)=>x.subjectId === subjectId);
    if (regionId) items = items.filter((x)=>(x.regionId || null) === regionId);
    if (query) {
        const q = query.toLowerCase();
        items = items.filter((x)=>{
            return (x.quizTitle || '').toLowerCase().includes(q) || (x.subjectTitle || '').toLowerCase().includes(q) || (x.region || '').toLowerCase().includes(q);
        });
    }
    return items;
}
class $df720c5fae68234e$export$801bf3ab7c08ab0d {
    /**
	 * @param {object} params
	 * @param {HTMLElement} params.root
	 * @param {string} [params.indexUrl] default: ../static/quizzes/index.json
	 */ constructor({ root: root, state: state = null, view: view = null, indexUrl: indexUrl = '../static/quizzes/index.json' } = {}){
        if (!root) throw new Error('[QuizzesController] root is required');
        this.root = root;
        this.indexUrl = indexUrl;
        // Respeta datos existentes si los hay
        this.state = state || new (0, $4e5ab73602d3c74b$export$8f193c612aecdea)({
            viewMode: 'subjects'
        });
        this.view = view || new (0, $6c4bdedaa4ec98dc$export$d01b8c10d7ef31c1)({
            root: root
        });
        this._indexJson = null;
        this._flatItems = [];
        this.favs = null;
    }
    async init() {
        // 1) UI bindings
        this.view.bindUI();
        this._initFromURL();
        this.favs = (0, $50f652c3ec429727$export$3ed93091135e143f)({
            root: document.querySelector('[data-quizzes-root]') || document,
            storageKey: 'selectivia:favs'
        });
        // 2) View -> State (event handlers)
        this.view.on('search', ({ query: query })=>this.state.setQuery(query));
        //this.view.on('query', ({ query }) => this.state.setQuery(query));
        this.view.on('subject', ({ subjectId: subjectId })=>this.state.setSubject(subjectId));
        this.view.on('region', ({ regionId: regionId })=>this.state.setRegion(regionId));
        this.view.on('clear', ()=>this.state.resetAll());
        this.view.on('loadMore', ()=>this.state.loadMore());
        // vistas: subjects/list
        this.view.on('view', ({ viewMode: viewMode })=>this.state.setViewMode(viewMode));
        //actions
        this.view.on('openSubject', ({ subjectId: subjectId })=>{
            this.state.setSubject(subjectId);
        });
        this.view.on('openQuiz', ({ subjectId: subjectId, quizId: quizId })=>window.alert('[not_implemented]'));
        // 3) State -> Render (subscribe)
        this._unsub = this.state.subscribe((snap, meta)=>{
            if (!this._flatItems) return;
            this._renderFromState(snap);
            // ✅ sync solo tras acciones del usuario (no en meta init)
            if (meta?.type !== 'init') this._syncURLFromState(snap);
        });
        // 4) Load data
        this.view.setStatus("Cargando cuestionarios\u2026");
        try {
            this._indexJson = await $df720c5fae68234e$var$fetchIndexJson(this.indexUrl);
            this._flatItems = $df720c5fae68234e$var$flattenIndex(this._indexJson);
            const subjects = Array.isArray(this._indexJson?.subjects) ? this._indexJson.subjects : [];
            this.view.setStatus('');
            // render inicial
            this.view.renderSubjectOptions(subjects);
            this._renderFromState(this.state.getSnapshot());
        } catch (err) {
            console.error(err);
            this.view.setStatus("No se pudo cargar el \xedndice de cuestionarios.");
        }
    }
    destroy() {
        if (this._unsub) this._unsub();
    }
    /* =========================
	   Render decisions
	========================= */ _renderFromState(snap) {
        const filters = this.state.getFilterParams();
        //const mustList = Boolean(filters.query || filters.subjectId);
        const mustList = Boolean(filters.query || filters.subjectId || window.__QUIZZES_TEST_MULT__ || window.__QUIZZES_FORCE_LIST__);
        // =========================
        // LIST VIEW (quizzes)
        // =========================
        if (mustList) {
            const filtered = $df720c5fae68234e$var$filterItems(this._flatItems, filters);
            const total = filtered.length;
            const visible = filtered.slice(0, snap.visibleCount);
            const loaded = visible.length;
            const vm = {
                viewMode: 'list',
                inputs: {
                    query: snap.query,
                    regionId: snap.regionId,
                    subjectId: snap.subjectId
                },
                pager: {
                    loaded: visible.length,
                    total: filtered.length,
                    hasMore: loaded < total
                },
                quizItems: visible,
                subjectCards: []
            };
            this.view.render(vm);
            this.favs?.apply(this.view.root); //setea favoritos
            return;
        }
        // =========================
        // SUBJECTS VIEW (cards)
        // =========================
        const subjects = Array.isArray(this._indexJson?.subjects) ? this._indexJson.subjects : [];
        const regionId = filters.regionId;
        const subjectCards = subjects.map((s)=>{
            const quizzes = Array.isArray(s.quizzes) ? s.quizzes : [];
            const filteredQuizzes = regionId ? quizzes.filter((q)=>(q.regionId || null) === regionId) : quizzes;
            const latest = filteredQuizzes.slice(0, 3).map((q)=>({
                    quizTitle: q.quizTitle,
                    region: q.region || null,
                    regionId: q.regionId || null,
                    quizId: q.quizId || null
                }));
            return {
                subjectId: s.subjectId,
                subjectTitle: s.subjectTitle,
                total: filteredQuizzes.length,
                latest: latest
            };
        });
        const finalCards = regionId ? subjectCards.filter((c)=>c.total > 0) : subjectCards;
        const vm = {
            viewMode: 'subjects',
            inputs: {
                query: snap.query,
                regionId: snap.regionId,
                subjectId: snap.subjectId
            },
            // En subjects no hay paginación
            pager: {
                loaded: 0,
                total: 0,
                hasMore: false
            },
            quizItems: [],
            subjectCards: finalCards
        };
        this.view.render(vm);
        this.favs?.apply(this.view.root); //setea favoritos
    }
    _initFromURL() {
        const url = new URL(window.location.href);
        const subjectId = url.searchParams.get('subject') || null;
        const regionId = url.searchParams.get('region') || null;
        const query = url.searchParams.get('q') || '';
        return {
            subjectId: subjectId,
            regionId: regionId,
            query: query
        };
    }
    _syncURLFromState(snap) {
        const url = new URL(window.location.href);
        if (snap.subjectId) url.searchParams.set('subject', snap.subjectId);
        else url.searchParams.delete('subject');
        if (snap.regionId) url.searchParams.set('region', snap.regionId);
        else url.searchParams.delete('region');
        if (snap.query) url.searchParams.set('q', snap.query);
        else url.searchParams.delete('q');
        // sin recargar
        window.history.replaceState({}, '', url);
    }
}



document.addEventListener('DOMContentLoaded', ()=>{
    //Header
    (0, $lA1wN.initHeaderActiveNav)();
    (0, $lA1wN.initHeaderCTA)();
    //Main Content
    const root = document.querySelector('[data-quizzes-root]');
    if (!root) {
        console.warn('[quizzes/main] Root [data-quizzes-root] not found');
        return;
    }
    const initial = $06edba64ec0c9b4f$var$readInitialStateFromURL();
    const state = new (0, $4e5ab73602d3c74b$export$8f193c612aecdea)({
        ...initial
    });
    const view = new (0, $6c4bdedaa4ec98dc$export$d01b8c10d7ef31c1)({
        root: root
    });
    const controller = new (0, $df720c5fae68234e$export$801bf3ab7c08ab0d)({
        root: root,
        state: state,
        view: view
    });
    controller.init();
});
function $06edba64ec0c9b4f$var$readInitialStateFromURL() {
    const url = new URL(window.location.href);
    const subjectId = url.searchParams.get('subject') || null;
    const regionId = url.searchParams.get('region') || null;
    const query = (url.searchParams.get('q') || '').trim();
    // Regla UX: subject o query => lista
    const viewMode = subjectId || query ? 'list' : 'subjects';
    return {
        subjectId: subjectId,
        regionId: regionId,
        query: query,
        viewMode: viewMode
    };
}


//# sourceMappingURL=quizzes.6595d51c.js.map
